import React, {useEffect} from 'react';
import Decorazione1 from '../components/decorazioni/1decorazione';
import Decorazione2 from '../components/decorazioni/2decorazione';
import Vino from '../components/vino';
import dati from '../dati/ViniDati.json';
import L30Foto from '../immaginiDino/vinoImg/vino1.png';
import SagrantinoFoto from '../immaginiDino/vinoImg/SagrantinoFoto.png';
function Vini(){
    
    const trenta = dati.Trenta;
    const sagr = dati.Sagrantino;
    useEffect(() => {
        document.title = "Vini - Cantina Testacalla";
    }, []);

    return(
    <>
        <div className='flex flex-col pt-[100px] pb-[50px] items-center mb-16'>
            <Vino foto={L30Foto} nome={trenta.titolo} descrizione={trenta.descrizione} link={trenta.link}
                  colore={trenta.colore} testo={trenta.testo} vendita={'Disponibile per la vendita in bottiglie da 0,75 lt.'}/>
            <div className='h-[1px] lg:h-0 w-full bg-[#CB3737] max-w-[20%] rounded-2xl mt-[60px] mb-[100px]'></div>
            <Vino foto={SagrantinoFoto} nome={sagr.titolo} descrizione={sagr.descrizione} link={sagr.link}
                  colore={sagr.colore} testo={sagr.testo} vendita={'Disponibile per la vendita in bottiglie da 0,75 lt.'}/>
            <div className='h-[1px] lg:h-0 w-full bg-[#CB3737] max-w-[20%] rounded-2xl mt-[60px] mb-[100px]'></div>
            <Vino foto={SagrantinoFoto} nome='Sagrantino secco L45' descrizione={
                'Sicuramente il vino delle grandi occasioni, composto al 100% dalle uve del vitigno autoctono. \n' +
                'Dal gusto forte e secco, presenta un colore rosso intenso, ma tuttavia il suo sapore è delicato, asciutto e aromatico e richiama infatti  le more di rovo. \n' +
                'Si consiglia di accompagnarlo con piatti ricchi come arrosti di carne rossa o selvaggina.\n' +
                'Curiosità: \n' +
                'La Cantina Testacalla dedica al trattore L45 il nome di questo vino. Questo mezzo veniva utilizzato in passato solo per lavori pesanti e in poche occasioni, così come veniva bevuto raramente questo vino di grande pregio.\n'
            } link={sagr.link}
                  colore={sagr.colore} testo={sagr.testo} vendita={'Disponibile per la vendita in bottiglie da 0,75 lt.'}/>
        </div>
    </>
    )
};
export default Vini;